import styled, { keyframes } from "styled-components";
import Loader from "../../assets/Loader.svg";

export const IntroductionWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  margin: 143px 165px;
  width: 772px;
  height: 367px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
`;

export const IntroductionTitle = styled.h1`
  color: #fff;
  font-size: 40px;
  line-height: 47.2px;
  font-family: UbuntuRegular;
  font-weight: 500;
  text-align: center;
`;
export const IntroductionSubTitle = styled.h2`
  color: #fff;
  font-size: 24px;
  line-height: 28.32px;
  font-family: UbuntuRegular;
  font-weight: 500;
  text-align: center;
`;
export const IntroductionTextWrapper = styled.div``;

export const IntroductionTextLink = styled.p`
  color: #fff;
  font-size: 20px;
  line-height: 23.6px;
  font-family: UbuntuLight;
  font-weight: 300;
  text-align: center;
`;

export const IntroductionText = styled.h2`
  color: #fff;
  font-size: 24px;
  line-height: 28.32px;
  font-family: UbuntuRegular;
  font-weight: 500;
  text-align: center;
`;

export const IntorductionButton = styled.a`
  letter-spacing: 0.75px;
  vertical-align: center;
  text-align: center;
  line-height: 28px;
  font-size: 16px;
  font-family: UbuntuBold;
  color: #08183f;
  cursor: pointer;

  box-shadow: 0px 4px 27px rgba(0, 150, 198, 0.42);
  border-radius: 48px;
  border: 2px solid #0096c6;
  background: #ffffff;
  height: 58px;
  padding: 10px 40px 10px 40px;
  margin-top: 60px;
`;
export const WithoutSidebarWrapper = styled.div`
  height: 100vh;
`;

const Spin = keyframes`
  0% {
    transform: rotate(0)
  }
  12.5% {
    transform: rotate(45deg)
  }
  25% {
    transform: rotate(90deg)
  }
  37.5% {
    transform: rotate(135deg)
  }
  50% {
    transform: rotate(180deg)
  }
  62.5% {
    transform: rotate(225deg)
  }
  75% {
    transform: rotate(270deg)
  }
  87.5% {
    transform: rotate(315deg)
  }
  100% {
    transform: rotate(360deg)
  }
`;

export const LoaderSign = styled.div`
  width: ${({ loader_size }) => loader_size || "10rem"};
  height: ${({ loader_size }) => loader_size || "10rem"};
  background-image: url(${Loader});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: rem;
  animation: ${Spin} 800ms infinite;
  animation-timing-function: steps(1);
  position: absolute;
  right: 48%;
  top: 48%;
`;

export const StyledSetRGSURL = styled.div`
  position: absolute;
  top: 30px;
  right: 30px;

  > label {
    color: #fff;
  }
  > input {
    width: 100%;
    padding: 0 5px;
    border-radius: 5px;
    border: none;
  }
`;

export const StyledShowVariablesButton = styled.button`
  position: absolute;
  top: 30px;
  right: 30px;
  letter-spacing: 0.75px;
  vertical-align: center;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  font-family: UbuntuBold;
  color: #08183f;
  cursor: pointer;

  box-shadow: 0px 4px 27px rgba(0, 150, 198, 0.42);
  border-radius: 48px;
  border: 2px solid #0096c6;
  background: #ffffff;
  padding: 5px 8px;
`;
